<template>
	<span v-html="t(tag)" :data-tag="tag">

	</span>
</template>

<script>
	export default {
		name: "t",
		props: {
			tag:{
				type: String
			}
		},
		computed:{

		},
		mounted(){

		}
	}
</script>

<style lang="scss">

</style>